module.exports = __webpack_public_path__ + "static/media/Overjet (sagittal fissure)9.5c40e239.png";